if (!customElements.get('product-subscription-form')) {
    class ProductSubscriptionForm extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init() {
            this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
            this.options = this.data[0];
            this.formSelector = this.options.formSelector;
            this.sellingPlanGroupsSelector = this.options.sellingPlanGroupsSelector;
            this.sellingPlanIdInputSelector = this.options.sellingPlanIdInputSelector;
            this.priceContainerSelector = this.options.priceContainerSelector;
            this.regularPriceSelector = this.options.regularPriceSelector;
            this.salePriceSelector = this.options.salePriceSelector;
            this.variantSelectorSelector = this.options.variantSelectorSelector;

            this.product = this.options.product;
            this.groupToSellingPlans = this.options.groupToSellingPlans;
            this.variantToPrice = this.options.variantToPrice;
            this.variantToSellingPlanAllocations =
                this.options.variantToSellingPlanAllocations;
            this.priceDisplayMode = this.options.priceDisplayMode || "strike";
            this.showSubscriptionDiscountBadge = !!this.options.showSubscriptionDiscountBadge;

            this.initialize();


        }

        initialize() {
            this.$form = this.closest(this.formSelector);
            this.$sellingPlanIdInput = this.querySelectorAll(
                this.sellingPlanIdInputSelector
            );

            const $variantSelector = this.$form.querySelector('input[name="id"]');
            $variantSelector.addEventListener("change", (e) => {
                const selectedVaraint = parseInt(e.target.value, 10);

                const variantPrice = this.options.variantToPrice[selectedVaraint];
                const onetimePriceSelector = this.querySelector('.rtx_option--onetime .rtx_option_subheading');
                if (variantPrice != undefined) {
                    onetimePriceSelector.textContent = variantPrice.priceFormatted;
                    var sellingPlanGroups = this.querySelectorAll(".rtx_option--sub");
                    sellingPlanGroups.forEach((sellingPlanGroup) => {
                        this.hideElement(sellingPlanGroup);
                    });
                    this.querySelector(".rtx_option--onetime").click();
                    const variantSellingPlanAllocations =
                        this.variantToSellingPlanAllocations[selectedVaraint];
                    if (variantSellingPlanAllocations) {
                        variantSellingPlanAllocations.forEach((allocation) => {
                            var sellingPlanSelector = this.querySelector(
                                `.rtx_option[data-group-id="${allocation.sellingPlanGroupId}"]`
                            );
                            var sellingPlanSelectorPrice = this.querySelector(
                                `.rtx_option[data-group-id="${allocation.sellingPlanGroupId}"] .rtx_option_subheading`
                            );
                            sellingPlanSelectorPrice.textContent = allocation.priceFormatted;
                            this.showElement(sellingPlanSelector);
                        });
                    }
                }
                this.querySelector('.rtx_option--onetime label').click();
            });

            var productForm = this.querySelector(this.formSelector);
            var variantSelector = this.querySelector('.pdp-variant-selector')
            var rtxnParentBlock = this.querySelector(".rtxn-block");
            if (productForm && rtxnParentBlock) {
                var fragment = this.createDocumentFragment();
                fragment.appendChild(rtxnParentBlock);
                variantSelector.parentNode.insertBefore(fragment, variantSelector.nextSibling);
                // productForm.prepend(fragment);
            }

            // Utility function to easily update the selected selling plan and related elements


            this.querySelector(".rtx_option_plans_dropdown")
                .addEventListener("change", (e) => {
                    this.setSellingPlan();
                });

            this.querySelectorAll('input[name="selling_plan_select"]')
                .forEach((rbi) => {
                    rbi.addEventListener("change", (e) => {
                        var selected = this.querySelector(
                            'input[name="selling_plan_select"]:checked'
                        );
                        var sellingPlanGroupId = selected
                            .closest(".rtx_option")
                            .getAttribute("data-group-id");
                        this.querySelectorAll(".rtx_option").forEach((option) => {
                            option.classList.remove("option--active");
                        });
                        selected.closest(".rtx_option").classList.add("option--active");
                        if (selected.value === "onetime") {
                            this.querySelectorAll(".rtx_option_plans")
                                .forEach((plans) => {
                                    plans.style.display = "none";
                                });
                        } else {
                            this.querySelectorAll(".rtx_option_plans")
                                .forEach((plans) => {
                                    plans.style.display = "block";
                                });
                            this.querySelectorAll(".rtx_option_plans select").forEach((select) => this.hideElement(select));
                            this.showElement(
                                this.querySelector(
                                    `.rtx_option_plans select[data-group-id="${sellingPlanGroupId}"]`
                                )
                            );
                        }
                        this.setSellingPlan();
                    });
                });
        }

        showElement(element) {
            return element.classList.remove("hide");
        }

        hideElement(element) {
            if (
                typeof element !== "undefined" &&
                !element.classList.contains("hide")
            ) {
                return element.classList.add("hide");
            }
        }

        setSellingPlan() {
            var selectedVariant = this.$form.querySelector('input[name="id"]').value;
            var selectedOption = this.querySelector(
                'input[name="selling_plan_select"]:checked'
            );
            this.querySelector('input[name="selling_plan"]').value = "";
            if (selectedOption.value === "onetime") {
                this.querySelector('input[name="selling_plan"]').value = "";
                this.querySelectorAll(".rtx_option_plans").forEach((plans) => {
                    plans.style.display = "none";
                });
            } else {
                var sellingPlanDropdowns = this.querySelectorAll(
                    ".rtx_option_plans_dropdown"
                );
                var sellingPlanDropdown;
                sellingPlanDropdowns.forEach((dropdown) => {
                    if (!dropdown.classList.contains("hide")) {
                        sellingPlanDropdown = dropdown;
                    }
                });
                var sellingPlanId = sellingPlanDropdown.value;
                const variantAllocation = this.variantToSellingPlanAllocations[
                    selectedVariant
                    ].find((alloc) => alloc.sellingPlanId == sellingPlanId);
                this.querySelector(
                    `.rtx_option--sub[data-group-id="${variantAllocation.sellingPlanGroupId}"] .rtx_option_subheading`
                ).textContent = variantAllocation.priceFormatted;
                this.querySelector('input[name="selling_plan"]').value =
                    sellingPlanId;
                this.querySelectorAll(".rtx_option_plans").forEach((plans) => {
                    plans.style.display = "block";
                });
            }
        }
    }

    customElements.define('product-subscription-form', ProductSubscriptionForm);
}